import { useAppDispatch } from 'state/store';
import { format } from 'date-fns';
import { DATE_DD_MON_YEAR } from 'constants/dateFormat';
import { JOB_ANY_DATE } from 'scenes/jobs/constants';
import {
  updateStatus,
  updateType,
  updateStarted,
} from '../../reducers/jobsSlice';

export type UseJobsAction = {
  setJobStatus: (status: string) => void;
  setJobType: (type: string) => void;
  setJobStarted: (date?: Date) => void;
};

export const useJobsActions = (): UseJobsAction => {
  const dispatch = useAppDispatch();

  return {
    setJobStatus: (status: string) => dispatch(updateStatus(status)),

    setJobType: (type: string) => dispatch(updateType(type)),

    setJobStarted: (date?: Date) => {
      if (!date) {
        dispatch(updateStarted(JOB_ANY_DATE));
        return;
      }

      dispatch(updateStarted(format(date, DATE_DD_MON_YEAR)));
    },
  };
};
